/* eslint key-spacing: 'off', comma-spacing: 'off' */
import modelHelper from '@/scripts/logisticRegression/modelHelper';
import commonModelHelper from '@/scripts/commonModelHelper';
import current from '@/scripts/current';
import VariableSelection from '@/bo/VariableSelection';
import store from '@/store';

export default {
    getLoadTime: function (selectedRecordCount) {
        var v = current.selectionModel.v;
        var model = {
            NumberOfRecords: selectedRecordCount
        };
        var milliseconds = (0.070264 * model.NumberOfRecords) + 161.944502;
        milliseconds *= 1.5;// Make it larger so that it returns quicker than the user expects
        var seconds = Math.ceil(milliseconds / 1000);
        //Divide by 3 for QA and Prod
        return seconds;
    },
    isValid: {
        years: function () {
            switch (store.state.selModel.years.selectionType) {
                case 'single':
                    return store.state.selModel.years.single > 0;
                case 'combine':
                case 'compare':
                    return store.state.selModel.years.values.length >= 2;
                default:
                    return false;
            }
            //return store.state.selModel.years.single > 0 || store.state.selModel.years.values.length >= 2;
        },
        location: function (selectionModel) {
            const isSet = store.state.selModel.locations.isSet;
            return isSet;
        },
        selectDependentVariable: function (selectionModel) {
            if (!selectionModel.v.dependent)
                selectionModel.v.dependent = VariableSelection.newNotIncluded();
            return selectionModel.v.dependent.isSelected();
        },
        selectIndependentVariables: function (selectionModel) {
            var allowedVariableTypes = modelHelper.getAllowedSelections('independent', null);
            var locationIsSatisfied = modelHelper.isVariableSelected(allowedVariableTypes, 'location');
            var yearIsSatistified = modelHelper.isVariableSelected(allowedVariableTypes, 'year');
            return selectionModel.v.independent.length > 0 && locationIsSatisfied && yearIsSatistified;
        },
        setReference: function (selectionModel) {
            return Boolean(selectionModel.reference);
        },
        viewreport: function (selectionModel) {
            return true;
        }
    },
    makeModelValid: function () {
        var v = current.selectionModel.v;
        if (v.dependent === undefined || v.dependent === null)
            v.dependent = VariableSelection.newNotIncluded();
        if (v.independent === undefined || v.independent === null)
            v.independent = [];
    },
    isVariableSelected: function (allowedVariableTypes, variableName) {
        var selectionModel = current.selectionModel;
        if (!allowedVariableTypes[variableName])
            return true;
        if (selectionModel.v.dependent !== undefined && selectionModel.v.dependent !== null && selectionModel.v.dependent.variable !== null &&
            selectionModel.v.dependent.variable.variable === variableName)
            return true;
        var matchingIndependentVariables = selectionModel.v.independent.filter(v => v.variable.variable === variableName);
        return matchingIndependentVariables.length > 0;

    },
    resetValuesForCurrentStep: function (currentStep) {
        var stepIndex = current.navigation.stepIndex[currentStep];
        if (stepIndex < current.navigation.stepIndex.years)
            commonModelHelper.resetYear();
        if (stepIndex < current.navigation.stepIndex.location)
            commonModelHelper.resetLocation();
        if (stepIndex < current.navigation.stepIndex.selectDependentVariable) {
            current.selectionModel.v.dependent = VariableSelection.newNotIncluded();
        }
        if (stepIndex < current.navigation.stepIndex.selectIndependentVariables)
            current.selectionModel.v.independent = [];
        if (stepIndex < current.navigation.stepIndex.setReference)
            current.selectionModel.reference = current.modelHelper.buildBlankReference();
    },
    buildBlankReference: function () {
        return {
            dependent: 0,
            independent: []
        }
    },
    modelIsComplete: function (model, currentStep) {
        var isValid = true;
        var stepIndex = current.navigation.stepIndex[currentStep];
        if (stepIndex >= current.navigation.stepIndex.years)
            isValid = isValid && current.modelHelper.isValid.years();
        if (stepIndex >= current.navigation.stepIndex.location)
            isValid = isValid && current.modelHelper.isValid.location();
        if (stepIndex >= current.navigation.stepIndex.selectDependentVariable)
            isValid = isValid && current.modelHelper.isValid.selectDependentVariable(model);
        if (stepIndex >= current.navigation.stepIndex.selectIndependentVariables)
            isValid = isValid && current.modelHelper.isValid.selectIndependentVariables(model);
        if (stepIndex >= current.navigation.stepIndex.setReference)
            isValid = isValid && current.modelHelper.isValid.setReference(model);
        return isValid;
    },

    getAllowedSelections: function (variableType, omittedVariables) {
        var comparingYears = store.state.selModel.years.selectionType === 'compare';
        var comparingLocations = store.state.selModel.locations.selectionType === 'compare';
        var selections = {
            year: comparingYears && (omittedVariables === null || !omittedVariables.year),
            location: comparingLocations && (omittedVariables === null || !omittedVariables.location),
            variable: true,
            count: 0,
            comparingYears: comparingYears,
            comparingLocations: comparingLocations,
            isRequired: false,
            isAllowed: true,
            defaultType: null
        };
        //if (variableType === 'control1' && (selections.year && selections.location) ||
        //  (variableType === 'control2' && (selections.year || selections.location)))
        //  selections.variable = false;
        selections.count = (selections.year ? 1 : 0) + (selections.location ? 1 : 0) + (selections.variable ? 1 : 0);
        if (selections.count === 1)
            selections.defaultType = selections.year ? 'year' : (selections.location ? 'location' : 'variable');
        selections.isRequired = variableType === 'dependent' || selections.year || selections.location;

        return selections;
    },
    resetAllValues: function () {
        commonModelHelper.resetYear();
        commonModelHelper.resetLocation();
        current.selectionModel.v.dependent = VariableSelection.newNotIncluded();
        current.selectionModel.v.independent = [];
        current.selectionModel.reference = current.modelHelper.buildBlankReference();
    }
}
